import { css } from '@linaria/core';
import { pulseAnimation } from '../primitives/Placeholder';
export const Root = {
    base: css `
		position: relative;

		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;

		width: 100%;
		/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
		color: rgba(0, 0, 0, 0);

		background: rgb(var(--background-color-base));
		&:before {
			content: '';
			display: block;
		}

		> img {
			position: absolute;
			z-index: 1;
			top: 0;
			left: 0;

			width: 100%;
			height: 100%;

			object-fit: cover;
		}
	`,
    isRound: css `
		border-radius: 50%;
	`,
    isLoading: css `
		height: auto;
		background: rgb(var(--teaser-color-base-background-loading-alpha));
		animation-direction: alternate-reverse;
	`,
    ratio: {
        '1x1': css `
			&:before {
				padding-top: calc((100% * 1) / 1);
			}
		`,
        '3x4': css `
			&:before {
				padding-top: calc((100% * 4) / 3);
			}
		`,
        '16x7': css `
			&:before {
				padding-top: calc((100% * 7) / 16);
			}
		`,
        '16x9': css `
			&:before {
				padding-top: calc((100% * 9) / 16);
			}
		`,
        '24x9': css `
			&:before {
				padding-top: calc((100% * 9) / 24);
			}
		`,
        '32x7': css `
			&:before {
				padding-top: calc((100% * 7) / 32);
			}
		`,
    },
};
export const PlaceholderImg = {
    base: css `
		position: absolute;
		top: 0;
		left: 0;

		display: flex;
		justify-content: center;

		width: 100%;
		height: 100%;
	`,
};
export const ChildRoot = {
    base: css ``,
    isLoading: css `
		${pulseAnimation};
		opacity: 1;
	`,
};
